import { fork } from "redux-saga/effects";

import watchCashPackages from "./components/cash_package/sagas";

const watchCashPackage = [
  fork(watchCashPackages)
];

export { watchCashPackage };
